import { render, staticRenderFns } from "./UmsUserRolesList.vue?vue&type=template&id=0f39a143&"
import script from "./UmsUserRolesList.vue?vue&type=script&lang=js&"
export * from "./UmsUserRolesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports